import React from 'react';
import { PopupOrPanel } from '../../../components/popupsAndPanels/PopupAndPanels';

type Props = {
  panelOpen: boolean;
  backToProfilePage: any;
  unableToSyncMsg: string;
};

export const UnableToSyncDataPopup: React.FC<Props> = ({
  panelOpen,
  backToProfilePage,
  unableToSyncMsg,
}) => {
  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={"Unable to Sync"}
      position="right"
      givenClass="WondeSyncData"
      noFooter={false}
      primaryBtnTxt="Close"     
      handleClose={() => backToProfilePage()}
      handlePrimaryBtn={() => backToProfilePage()}
      width={460}
    >
      <p>{unableToSyncMsg}</p>
    </PopupOrPanel>
  );  
};